var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"title":"Info & Hjälp"}},[_c('Card',{attrs:{"verticalMargin":false},domProps:{"innerHTML":_vm._s(_vm.bodyText)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }